import { useState, useRef } from 'react';
import { Upload, X, Loader2, Check } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function FileUploader({ onUploadComplete, accept = "image/*,video/*", label }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const fileInputRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 50 * 1024 * 1024) {
      toast.error('File troppo grande (max 50MB)');
      return;
    }

    setUploading(true);
    setProgress(0);

    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(`${BACKEND_URL}/api/upload`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => setProgress(Math.round((e.loaded * 100) / e.total))
      });

      const fileUrl = `${BACKEND_URL}/api/files/${response.data.path}`;
      onUploadComplete?.(fileUrl, response.data);
      toast.success('File caricato!');
    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Errore nel caricamento');
    } finally {
      setUploading(false);
      setProgress(0);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  return (
    <div className="relative">
      <input ref={fileInputRef} type="file" accept={accept} onChange={handleUpload} className="hidden" data-testid="file-upload-input" />
      <button
        onClick={() => fileInputRef.current?.click()}
        disabled={uploading}
        className="flex items-center gap-2 px-4 py-2 bg-blue-50 text-[#0066b2] border-2 border-dashed border-[#0066b2]/30 rounded-xl hover:bg-blue-100 transition-colors disabled:opacity-50 w-full justify-center"
        data-testid="file-upload-button"
      >
        {uploading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            <span>{progress}%</span>
          </>
        ) : (
          <>
            <Upload className="w-4 h-4" />
            <span>{label || 'Carica file'}</span>
          </>
        )}
      </button>
    </div>
  );
}
